// extracted by mini-css-extract-plugin
module.exports = {"property":"property_style_property__3icpS"};